import { NgModule } from "@angular/core"
import { CommonModule } from "@angular/common"
import { NavbarComponent } from "./navbar/navbar.component"
import { RouterModule } from "@angular/router"
import {
	MatMenuModule,
	MatButtonModule,
	MatListModule,
	MatRippleModule,
	MatTooltipModule,
	MatCardModule,
	MatTabsModule,
	MatProgressSpinnerModule,
	MatSelectModule,
	MatBadgeModule
} from "@angular/material"
import { NavbarBottomComponent } from "./navbar-bottom/navbar-bottom.component"
import { TranslateModule } from "@ngx-translate/core"
import { UserDropdownComponent } from "./user-dropdown/user-dropdown.component"

@NgModule({
	declarations: [NavbarComponent, NavbarBottomComponent, UserDropdownComponent],
	imports: [
		CommonModule,
		RouterModule,
		MatMenuModule,
		MatButtonModule,
		MatListModule,
		MatRippleModule,
		MatTooltipModule,
		MatCardModule,
		MatTabsModule,
		TranslateModule,
		MatProgressSpinnerModule,
		MatSelectModule,
		MatBadgeModule
	],
	exports: [NavbarComponent, NavbarBottomComponent]
})
export class LayoutModule {}
